import { ArrangementResource } from '@thiememeulenhoff/types';

export const ResourceBackgroundImage = (
  resource: ArrangementResource,
): string | undefined => {
  const backgroundImage = resource.navigationMetadata?.backgroundImage;

  if (backgroundImage) {
    return backgroundImage;
  }

  if (resource.children && resource.children[0]) {
    return ResourceBackgroundImage(resource.children[0]);
  }

  return undefined;
};
